import * as tslib_1 from "tslib";
import { observer } from 'mobx-react';
import { Check } from 'office-ui-fabric-react/lib/components/Check';
import { toggleSelectAllRows } from 'owa-mail-actions';
import { resetFocus } from 'owa-mail-focus-manager';
import { MailListFilter } from 'owa-mail-list-filter-view';
import { getIsEverythingSelectedInTable, listViewStore } from 'owa-mail-list-store';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import ReadingPanePosition from 'owa-session-store/lib/store/schema/ReadingPanePosition';
import * as React from 'react';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
var styles = require('./MailListHeader.scss');
var classNames = require('classnames/bind');
//  Header Structure
// ---------------------------------------------------------------------------------------------------
// |  Mail List Header Container                                                                     |
// |  ---------------------------------------------------------------------------------------------  |
// |  | First Row (Custom - renders optionally)                                                   |  |
// |  |                                                                                           |  |
// |  ---------------------------------------------------------------------------------------------  |
// |  ---------------------------------------------------------------------------------------------  |
// |  | Second Row (Half Custom - renders always)                                                 |  |
// |  | ---------- -----------------------------                        --------------------------|  |
// |  | |  Check | |           Custom          |                        |     Filter Dropdown    ||  |
// |  | |   Box  | |           Content         |                        |    (based on scenario) ||  |
// |  | ---------- -----------------------------                        --------------------------|  |
// |  ---------------------------------------------------------------------------------------------  |
// |  ---------------------------------------------------------------------------------------------  |
// |  | Third Row (Custom - renders optionally)                                                   |  |
// |  |                                                                                           |  |
// |  ---------------------------------------------------------------------------------------------  |
// |  ---------------------------------------------------------------------------------------------  |
// |  | Bulk action progress bar (Custom - renders optionally)                                    |  |
// |  |                                                                                           |  |
// |  ---------------------------------------------------------------------------------------------  |
// ---------------------------------------------------------------------------------------------------
var MailListHeader = /** @class */ (function (_super) {
    tslib_1.__extends(MailListHeader, _super);
    function MailListHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderSecondRowLeftEntity = function (isReadingPanePositionRight) {
            var tableView = listViewStore.tableViews.get(_this.props.tableViewId);
            var isListViewEmpty = tableView.rowKeys.length == 0;
            var isInCheckedMode = tableView.isInCheckedMode;
            var isEverythingSelected = getIsEverythingSelectedInTable(tableView);
            var leftEntityClassNames = classNames(styles.mailListSecondRowLeftEntity, isInCheckedMode && styles.showCheckbox, !isListViewEmpty && styles.listViewHasItems, isReadingPanePositionRight ? styles.leftEntityThreeColumn : styles.leftEntitySingleLine);
            var checkBoxClassNames = classNames(styles.checkBox, isReadingPanePositionRight ? styles.checkBoxThreeColumn : styles.checkBoxSingleLine);
            var checkBoxStyles = function () { return ({
                check: styles.checkStyles,
            }); };
            return (React.createElement("div", { className: leftEntityClassNames, onClick: !isListViewEmpty ? _this.toggleSelectAll(tableView) : undefined },
                _this.props.renderSecondRowIcon && (React.createElement("div", { className: styles.leftEntityIcon }, _this.props.renderSecondRowIcon(styles.secondRowLeftEntityIcon))),
                React.createElement(Check, { className: checkBoxClassNames, checked: isEverythingSelected, styles: checkBoxStyles })));
        };
        _this.toggleSelectAll = function (tableView) { return function (ev) {
            toggleSelectAllRows(tableView);
            // Must reset focus so that focus goes back to list view so user can perform keyboard triage actions as expected
            resetFocus();
        }; };
        _this.renderMailListFilter = function () {
            // Mentions is still shipping to WW so only add Mentions to view filter if feature is enabled
            var viewFilters = isMailFeatureEnabled('cmp-mentions')
                ? ['All', 'Unread', 'ToOrCcMe', 'Flagged', 'Mentioned', 'HasAttachment']
                : ['All', 'Unread', 'ToOrCcMe', 'Flagged', 'HasAttachment'];
            return (React.createElement(MailListFilter, { supportedViewFilters: viewFilters, filterMenuSource: _this.props.filterMenuSource, tableViewId: _this.props.tableViewId }));
        };
        return _this;
    }
    MailListHeader.prototype.render = function () {
        var isReadingPanePositionRight = getUserConfiguration().UserOptions.GlobalReadingPanePositionReact ==
            ReadingPanePosition.Right;
        var mailListThirdRowCss = classNames(isReadingPanePositionRight
            ? styles.mailListThirdRowThreeColumn
            : styles.mailListThirdRowSingleLine);
        if (!this.props.renderSecondRowCustomContent) {
            throw new Error('MailListHeader: renderSecondRowCustomContent should not be null');
        }
        return (React.createElement("div", { className: styles.mailListHeaderContainer },
            this.props.renderFirstRow && this.props.renderFirstRow(styles.mailListFirstRow),
            React.createElement("div", { className: styles.mailListSecondRow },
                this.renderSecondRowLeftEntity(isReadingPanePositionRight),
                this.props.renderSecondRowCustomContent(styles.mailListSecondRowCustomContainer),
                this.props.shouldShowFilterMenu && this.renderMailListFilter()),
            this.props.renderThirdRow && this.props.renderThirdRow(mailListThirdRowCss),
            this.props.renderBulkActionProgressBar && this.props.renderBulkActionProgressBar()));
    };
    MailListHeader = tslib_1.__decorate([
        observer
    ], MailListHeader);
    return MailListHeader;
}(React.Component));
export default MailListHeader;
//# sourceMappingURL=MailListHeader.js.map